import React from 'react';
import { observer } from 'mobx-react-lite';
import {FormControl, InputBase, Select} from "@material-ui/core";
import {createStyles, makeStyles, Theme, withStyles} from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import LanguageIcon from '@material-ui/icons/Language';
import Logo from "../core/Logo";
import {useTranslation} from "react-i18next";
import { Copyright } from '../core/Copyright';

const BootstrapInput = withStyles((theme: Theme) =>
    createStyles({
        root: {
            'label + &': {
                marginTop: theme.spacing(3),
            },
        },
        input: {
            borderRadius: 4,
            position: 'relative',
            backgroundColor: '#575756',
            color: '#fff',
            border: '1px solid #575756',
            fontWeight: 'bold',
            padding: '10px 26px 10px 12px',
            transition: theme.transitions.create(['border-color', 'box-shadow']),
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
        },
    }),
)(InputBase);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        container: {
            position: 'absolute',
            top: '117px',
            left: 360,
            right: 0,
            bottom: '22px',
            display: 'flex',
            flexDirection: 'column',
        },
        title: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'block',
            },
        },
        sectionDesktop: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
            },
        },
        mainToolbar: {
            backgroundColor: '#575756',
        },
        logo: {
            height: "100px",
            width: '100%',
            color: 'inherit',
            fill: 'currentColor',
            stroke: 'currentColor',
            overflow: 'visible',
        },
        mainLogo: {
            textAlign: 'center',
            color: 'white',
            backgroundColor: '#E2000F',
            height: '72px',
            width: '104px',
            position: 'absolute',
            left: '0',
        },
        margin: {
            margin: theme.spacing(1),
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
        },
    }),
);

type LayoutProps = {
    children: any;
    offset?: {
        left?: number;
        right?: number;
        top?: number;
        bottom?: number;
    };
}

const Layout = observer((props: LayoutProps) => {
    const classes = useStyles();
    const {children, offset} = props;
    const {i18n} = useTranslation();

    return(
        <div className={classes.root}>
            <AppBar position="static">
                <Toolbar variant="dense" className={classes.mainToolbar}>
                    <div className={classes.mainLogo}>
                        <Logo classes={classes.logo} viewBox={{X: 0, Y: 0, height: 280, width: 400}}/>
                    </div>
                    <div className={classes.root}/>
                    <div className={classes.sectionDesktop}>
                        <FormControl className={classes.margin}>
                            <LanguageIcon/>
                            <Select
                                labelId="language-select-label"
                                id="language-select"
                                value={i18n.language}
                                variant="standard"
                                onChange={async (value) => {
                                    await i18n.changeLanguage(value.target.value as string);
                                }}
                                input={<BootstrapInput/>}
                            >
                                <MenuItem value={'ru'}>Русский</MenuItem>
                                <MenuItem value={'en'}>English</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </Toolbar>
            </AppBar>
            <AppBar position="static"><Toolbar style={{backgroundColor: 'white'}}></Toolbar></AppBar>
            <div className={classes.container}
                style={{top: offset?.top, bottom: offset?.bottom, left: offset?.left, right: offset?.right}}
            >
                {children}
            </div>
            <Copyright/>
        </div>
    );
});

export default Layout;